export default "__VITE_ASSET__DvVVR5p5__"